/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useSelector } from "react-redux";
import CircularProgressWithLabel from "app/common/CircularProgressWithLabel";

const TaskProgressSnackbar = (props) => {
  const [progress, setProgress] = React.useState(0);
  const tasksSlice = useSelector((state) => state.tasks);
  const { taskId } = props;

  React.useEffect(() => {
    if (tasksSlice[taskId]?.progress) setProgress(tasksSlice[taskId]?.progress);
  }, [tasksSlice[taskId]]);

  const progressProps = { ...props };
  delete progressProps.taskId;

  return <CircularProgressWithLabel {...progressProps} value={progress} />;
};

export default TaskProgressSnackbar;
